<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  multiTemplateDataRows
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="hotlist">
    <mat-header-cell *matHeaderCellDef mat-sort-header="name">{{ 'common.hotlist' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{ item.name }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="provider">
    <mat-header-cell *matHeaderCellDef mat-sort-header="provider">{{ 'vehicleIntelligence.hotlist.provider' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="text-truncate">{{ item.provider }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="filterAlerts">
    <mat-header-cell *matHeaderCellDef>{{ 'vehicleIntelligence.hotlist.filterAlerts' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <ng-container *ngIf="item.filterAlerts; else notFilteringAlerts">
        <sn-icon>check</sn-icon>
      </ng-container>
      <ng-template #notFilteringAlerts>
        <sn-icon>close</sn-icon>
      </ng-template>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="showHotlist(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
